module.exports = __webpack_public_path__ + "img/dashboard_quotes.1949adb.png";